import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import {
	ToothFracturePosition,
	ToothFractureType,
	ToothSurface,
} from '../../../../../graphql/graphql';

export const Tooth31: ToothDataEntry = {
	[ToothView.LINGUAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M97.2,376.2l1.9,20.1,1.7,13,1.8,11.3,1.7,16.5.6,12.7-1.3,8.5-2.1,3.8-4.1,4.6-9.2,4.4-14.3.8-8.5,2.2-9.4-2-17.1-1.4-5.9-3.7-3.6-5.8-1.6-5.2.3-12.4,2.8-16.9,5.5-23.9,8-26.4s21.9-37.1,52.8-.2Z',
			},
			[ToothSurface.Lingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M78,395.7a8.9,8.9 0 1,1 -17.8,0a8.9,8.9 0 1,1 17.8,0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M41.8,385.3l-9.8,39.7s44.8-10.2,9.8-39.7Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M97.8,385.5l5.2,41.3s-41.6-13.2-5.2-41.3Z',
			},
			[ToothSurface.CervicalLingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M44.4,376.4s21.9-37.1,52.8-.2l-1.2-7.3s-26.5-30.9-49.6-.5l-2,8Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M43.7,380.8l-6.8,19.7-5.4,26.3-3.7,17.6-.4,11.2,3,8,7.6,7.9,20,1.4s11.4-63.6-14.3-92Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M97,379.8l2.2,15.5,2.2,16.9,3.1,19.3.5,5.2-.4,15.7-.8,6.8-5.7,8-9.8,4.6-14.6.5s-.5-77.2,23.3-92.6Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '27.6 446 104.9 446 104.7 452.6 103.3 459.3 97.4 467.7 87.4 471.7 65.2 474.1 38.5 471 32.6 466.5 27.6 456 27.6 446',
			},
			[ToothSurface.LingualSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M97.2,376.2l1.9,20.1,1.7,13,1.8,11.3,1.7,16.5.6,12.7-1.3,8.5-2.1,3.8-4.1,4.6-9.2,4.4-14.3.8-8.5,2.2-9.4-2-17.1-1.4-5.9-3.7-3.6-5.8-1.6-5.2.3-12.4,2.8-16.9,5.5-23.9,8-26.4s21.9-37.1,52.8-.2Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'32 427.5 41.1 417.4 43.4 433.9 50.4 414.2 55.9 433.9 62.5 413.3 68.6 432.6 75.2 413.3 81.1 432.8 87.5 413.3 92.4 432.4 96.1 416.7 103.4 427.9',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'74 149.3 68.2 161.2 73.5 166.5 67.9 172.1 73.2 177.5 67.5 183.2 72.8 188.5 67.4 193.9 73.1 199.6 67.5 205.2 72.9 210.6 67.7 215.8 73.7 221.7 68.1 227.3 73.2 232.3 67.2 238.3 72.7 243.7 67.5 248.9 73 254.5 67.9 259.5 73.6 265.2 68.3 270.4 73.2 275.2 68.8 279.6 73.7 284.5 69.1 289.1 74 294 69.1 298.9 73.7 303.5 69.3 308 73.9 312.6 68.2 318.3 73 323 68.1 327.9 73 332.8 67.5 338.3 72.7 343.5 66.8 349.4 71.9 354.5',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'58 260.4 61.3 255.5 64.4 260.5 68.1 255.1 71.9 260.5 75 254.8 78.5 259.6 81.4 255.5 83.8 259.9 86.1 255.1 88.1 259.7',
			],
		},
	},
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '46 84 57.2 67.7 61.7 63.4 65.5 61.8 69.7 60.7 75.3 61 81.9 64.4 87.6 68.9 94 76.4 100.9 86.7 102.7 88.6 108.2 90.7 110.5 93.6 111.6 95.7 112.1 100.3 112.1 103 111.1 106.7 109.6 108.9 108 111.9 104.9 114.2 101 118.9 97.7 123.3 94.7 127.8 87.3 133.1 81.5 136.2 70.8 136.1 66.7 135.7 61.3 133.5 49.2 124.3 46.8 120.4 40 114.7 38.7 113.4 35 109.8 32.5 106.8 30 102.3 27.8 97.9 27.5 92.7 30 88.6 32.4 86.9 37.1 84.9 41.2 84.5 46 84',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M51.7,115.4h39.2s-18.5,16.1-39.2,0Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M37.7,84.8l-3.5.5-3.3,2.1-2.4,3.5-.7,2v6l1.3,4,2.3,3.4,2.8,3.4,2,2.2,2,1.3s24.2-16.7-.5-28.2Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M101.6,86.2l4.6,3.1,3.6,2.6,2,2.8,1.3,4.4v3.8c-.1,0-1.4,4.3-1.4,4.3l-4.4,5.6s-32.4-10.8-5.7-26.6Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '37.7 84.8 100 85 104.8 88.2 109.9 91.9 111.8 94.6 113.1 99.1 113 102.9 111.7 107.2 107.3 112.8 38.2 113 36.2 111.7 34.2 109.5 31.4 106.1 29.1 102.8 27.8 98.8 27.8 92.8 28.5 90.8 31 87.3 34.2 85.2 37.7 84.8',
			},
			[ToothSurface.LingualSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M46,84l11.2-16.3,4.5-4.3,8-2.7,5.6.3,6.6,3.4,5.7,4.5,6.4,7.5,6.9,10.3,1.8,1.9,5.5,2.1,3.4,5,.5,7.3s-27.2,9.7-82.1-.7l-2.2-4.4-.3-5.2,2.5-4.1,2.4-1.7,4.7-2,8.9-.9Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M112.1,103s-27.8,9.7-82.1-.7l2.5,4.5,2.5,3,3.7,3.6,8.1,7,2.4,3.9,12.1,9.2,5.4,2.2,4.1.4h10.7c0,0,5.8-3,5.8-3l7.4-5.3,3-4.5,3.3-4.4,3.9-4.7,3.1-2.3,1.6-3,1.5-2.2,1-3.7',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Vertical}`]: [
				'28.7 94.9 39.1 106.4 41.6 87.6 49.7 110 55.9 87.6 63.5 111.2 70.5 89 78 111.2 84.8 88.7 92 111.2 97.7 89.3 101.9 107.2 110.3 94.3',
			],
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M43.4,149.4l-1.9-7.1-10.5-44.5-4.8-22.1-.2-11.3,1.9-9.9,3.5-6.6,13.2-7.5h11.6l11.3-5.5,9,2,22.1-.8,6.9,3.3,5.5,12,2,9.5-.4,12.4-7.3,53.6-3.6,14.2-1.5,8.8s-27.7,59.4-56.8-.5Z',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M47,114.7h49s-20.9,100.6-49,0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M27.1,80.2l10,42.9s43.5-38.4-10-42.9Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M112.2,74.7l-4.8,44.2s-49.3-30,4.8-44.2Z',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M43.4,149.4s25.1,59.5,56.8.5l-1.8,13.3s-26.6,46.8-54.3-1.9l-.7-11.9Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '25.9 72.6 26.3 58.7 30.4 49.1 42.6 40.7 55.8 40.2 68.4 35.2 99.6 35.2 106.8 40.9 110.5 48.6 112.8 57.7 112.8 67.4 112.8 72 25.9 72.6',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M41.5,141.4l-5.3-22.6-4.2-16.4-4.8-21.2-1.2-7.2.4-15,4.2-10.4,11.7-7.6,10.6-.9,4.8-.9s8.1,71.2-16.1,102.2Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M77.7,36.3l21.7-.4,5.3,2.8,3.7,6,4.1,10.1.4,5.8v10.9l-3.2,26-3.7,29.3-3.9,15c-23-20.1-24.4-105.6-24.4-105.6Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M43.4,149.4l-1.9-7.1-10.5-44.5-4.8-22.1-.2-11.3,1.9-9.9,3.5-6.6,13.2-7.5h11.6l11.3-5.5,9,2,22.1-.8,6.9,3.3,5.5,12,2,9.5-.4,12.4-7.3,53.6-3.6,14.2-1.5,8.8s-27.7,59.4-56.8-.5Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'33 103.2 42.7 113.8 44.9 96.4 52.5 117.2 58.2 96.4 65.2 118.2 71.6 97.7 78.7 118.2 84.9 97.4 91.7 118.2 96.9 98 100.7 114.6 108.6 102.6',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'78.2 376.2 83.4 364.1 77.9 359 83.3 353.1 77.7 348 83.2 342 77.6 337 82.9 331.3 76.9 325.8 82.2 320.1 76.6 314.9 81.6 309.5 75.4 303.8 80.7 298 75.4 293.2 81.1 287 75.4 281.8 80.4 276.3 74.6 271 79.5 265.8 73.6 260.4 78.6 254.9 73.6 250.3 77.7 245.8 72.6 241.1 77 236.3 71.9 231.6 76.6 226.5 71.8 222.1 76.1 217.4 71.3 213 76.7 207.1 71.7 202.6 76.4 197.4 71.3 192.7 76.5 187 71.1 182.1 76.8 175.9 71.5 171.1',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'58.7 273.6 62.5 279.3 66.2 273.5 70.6 279.9 75.1 273.5 78.8 280.2 82.9 274.6 86.3 279.3 89.1 274.1 91.9 279.9 94.2 274.4',
			],
		},
	},
};
